module.exports = __webpack_public_path__ + "static/media/arrow-left-carousel.0c799668.svg";